import React, { useEffect } from 'react';
import { string, func, object, number, array } from 'prop-types';
import ExpandableContent, { ExpandableContentSection } from 'ps-components/ExpandableContent/ExpandableContent';
import Incremental from 'ps-components/InputElements/Incremental/Incremental';
import Slider from 'ps-components/InputElements/Slider/Slider';
import Select from 'ps-components/ReactSelect/ReactSelect';
import { Options } from 'ps-design';

import './ModelsSettingsCard.scss';

const weightAverageOptions = ['Employee', 'Job'];

ModelsSettingsCard.propTypes = {
  buildRange: string,
  setBuildRange: func,
  weightAverage: string,
  setWeightAverage: func,
  midpointAverage: object,
  setMidpointAverage: func,
  rangeSpread: number,
  setRangeSpread: func,
  rounding: object,
  setRounding: func,
  midpointAdjustment: number,
  setMidpointAdjustment: func,
  targetElements: array,
  buildRangeOptions: array,
  roundOptions: array
};

export default function ModelsSettingsCard(props) {
  const {
    buildRange,
    setBuildRange,
    weightAverage,
    setWeightAverage,
    midpointAverage,
    setMidpointAverage,
    rangeSpread,
    setRangeSpread,
    rounding,
    setRounding,
    midpointAdjustment,
    setMidpointAdjustment,
    targetElements,
    buildRangeOptions,
    roundOptions
  } = props;

  useEffect(resetStates, [buildRange]);

  function handleSetBuildRange(id, value) {
    setBuildRange(value);
  }

  function handleSetWeightAverage(id, value) {
    setWeightAverage(value);
  }

  function resetStates() {
    setRounding(roundOptions[0]);
    setRangeSpread(50);
    setMidpointAverage(null);
    setMidpointAdjustment(0);
    setWeightAverage('Employee');
  }

  let expandedContent,
    maxHeight = 400,
    headerText = 'Market',
    hideBorder = false;
  switch (buildRange) {
    case 'Midpoint':
      headerText = 'Use Current Midpoint';
      maxHeight = 200;
      expandedContent = (
        <ExpandableContentSection hideBorder={true} className="model-settings__range-select">
          <div className="range-spread-container">
            <div className="model-settings__expand-label">Adjust Current Midpoint By</div>
            <Incremental
              className="model-settings__expand-incremental"
              setIncrement={setMidpointAdjustment}
              increment={midpointAdjustment}
            />
          </div>
          <div className="range-spread-container">
            <div className="model-settings__expand-label">Target Range Spread</div>
            <Slider
              defaultValue={50}
              max={100}
              min={0}
              setSliderValue={setRangeSpread}
              sliderValue={rangeSpread}
              isPercent={true}
            />
          </div>
          <div className="rounding-select-container">
            <div className="model-settings__expand-label dropdown">Round to Nearest</div>
            <Select
              darkMode={true}
              className="rounding-select"
              options={roundOptions}
              value={rounding}
              onChange={setRounding}
            />
          </div>
        </ExpandableContentSection>
      );
      break;
    case 'Market':
      headerText = 'Market';
      maxHeight = 350;
      expandedContent = (
        <React.Fragment>
          <ExpandableContentSection className="model-settings__weighting">
            <div className="select-averaging-container">
              <div className="model-settings__expand-label">Weight all averages by</div>
              <Options
                id="horizontal"
                onChange={handleSetWeightAverage}
                value={weightAverage}
                multiValue={false}
                optionProps={{ className: 'pxl-option--primary' }}
                options={weightAverageOptions}
                type="radio"
                horizontal={true}
              />
            </div>
            <div className="select-midpoint-container">
              <div className="model-settings__expand-label dropdown">Set Midpoint to the Average of</div>
              <Select
                darkMode={true}
                className="midpoint-select"
                options={targetElements}
                value={midpointAverage}
                onChange={setMidpointAverage}
              />
            </div>
          </ExpandableContentSection>
          <ExpandableContentSection hideBorder={true} className="model-settings__range-select">
            <div className="range-spread-container">
              <div className="model-settings__expand-label">Target Range Spread</div>
              <Slider
                defaultValue={50}
                max={100}
                min={0}
                setSliderValue={setRangeSpread}
                sliderValue={rangeSpread}
                isPercent={true}
              />
            </div>
            <div className="rounding-select-container">
              <div className="model-settings__expand-label dropdown">Round to Nearest</div>
              <Select
                darkMode={true}
                className="rounding-select"
                options={roundOptions}
                value={rounding}
                onChange={setRounding}
              />
            </div>
          </ExpandableContentSection>
        </React.Fragment>
      );
      break;
    case 'Keep Current Ranges':
      headerText = 'Keep Current Ranges';
      maxHeight = 100;
      hideBorder = true;
  }
  return (
    <ExpandableContent
      className="model-settings__card"
      defaultExpanded={true}
      headerText={headerText}
      maxHeight={maxHeight}
    >
      <ExpandableContentSection className="model-settings__select-build" hideBorder={hideBorder}>
        <div className="model-settings__expand-label">Select One to Build Range</div>
        <Options
          id="horizontal"
          onChange={handleSetBuildRange}
          value={buildRange}
          multiValue={false}
          optionProps={{ className: 'pxl-option--primary' }}
          options={buildRangeOptions}
          type="radio"
          horizontal={true}
        />
      </ExpandableContentSection>
      {expandedContent}
    </ExpandableContent>
  );
}
